// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3HnAC","checkboxCol":"Table_checkboxCol__3cMky","emailCol":"Table_emailCol__3t1C5","actionCol":"Table_actionCol__1cEQ7"};